var urlParams = {

  /*
    urlParams
    ---
    @paramNames = array, an array of parameters to look for and return the
    values of. Values are returned as an array.
    @url = string, optional string of a url with parameters. If not passed the
    function uses the current url of the browser.
  */
  get: function(paramNames, url) {
    // If no url arg use current url
    if (!url) url = window.location.href;
    // Get url query string and store each query in an array
    var queryArray = window.location.search.substring(1).split('&');
    // Placeholder for return array
    var queryValues = [];
    // Loop through the paramNames array
    for (var i = 0; i < paramNames.length; i++) {
      paramName = paramNames[i];
      // Loop through the queryArray
      Array.prototype.map.call(queryArray, function(param) {
        // If the current query paramname match the paramName store
        // push it to the quertValues return array.
        if(param.split('=')[0] == paramName) {
          queryValues.push(param.split('=')[1]);
        }
      });
    }
    // Retrun the queryValues array
    return queryValues;
  },

  /*
    urlParams - Set
    ---
    @queryObject = object where the key is the filter name and the value is an
    array of values.
  */
  set: function(queryObject) {
    // Get the url hostname and pathname
    var url = window.location.href.split('?')[0];
    // Placehoder for queries
    var queryArray = [];
    // Placeholder for query string
    var queryString = '?';
    // Loop through the query object of key and arrays as values
    for (var key in queryObject) {
      if (queryObject.hasOwnProperty(key)) {
        // If the object has a key store the key as the param name
        var paramName = key;
        // Loop through the value array of each queryObject key
        Array.prototype.map.call(queryObject[key], function(paramValue){
          // Push the param name and the param value as a string to the queryArray.
          queryArray.push(paramName + '=' + paramValue);
        });
      }
    }
    // Convert the array to a string
    queryString += queryArray.join('&');
    // Push the browser to the new url that includes params
    window.history.pushState('', document.title, url + queryString);
  },

  /*
    urlParams - Clear
    ---
    Clear any existing query string
  */
  clear: function() {
    // Get the current url hostname and pathname
    var url = window.location.href.split('?')[0];
    // Push the browser to a clean url without the query string
    window.history.pushState('', document.title, url);
  }
};
